module.exports = __webpack_public_path__ + "img/reloj.549947b6.gif";